import { Badge } from '@/components/ui/badge'
import { alertStatusLabel } from '@/lib/alertStatus'

export function AlertStatusBadge({ isActive }) {
  if (isActive) {
    return <Badge variant="success">{alertStatusLabel(true)}</Badge>
  }
  return <Badge variant="secondary">{alertStatusLabel(false)}</Badge>
}
